import { getClient } from './client'

export const getEntryById = async (id: string, fields?: string[]) => {
  const client = getClient()
  try {
    const entry = await client.entries.get({
      id: id,
      ...(fields && { fields })
    })
    // console.log(entry)
    return entry
  } catch (err) {
    console.log(err)
    return null
  }
}

export async function getEntriesByIds(ids: string[]) {
  // console.log('getEntriesByIds called with:', ids)
  if (!ids.length) return []
  const results = await Promise.all(ids.map(id => getEntryById(id)))
  return results
}
